import React, { FC, useEffect, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import BagIcon from "components/BagIcon";
import NcInputNumber from "components/NcInputNumber";
import { PRODUCTS, Product } from "data/data";

import Prices from "components/Prices";
import ModalViewAllReviews from "./ModalViewAllReviews";
import { apiGetItemData } from "services/MenuService";
import { useLocation, useParams } from "react-router-dom";
import NcImage from "shared/NcImage/NcImage";

import Cookies from "js-cookie";

import ProductContent from "./ProductContent";
export interface ProductDetailPageProps {
  className?: string;
}

const ProductDetailPage: FC<ProductDetailPageProps> = ({ className = "" }) => {
  const location = useLocation();
  const [qualitySelected, setQualitySelected] = React.useState(1);
  const [isOpenModalViewAllReviews, setIsOpenModalViewAllReviews] =
    useState(false);
  const [requiredCheck, setRequiredCheck] = useState(false);
  const [showError, setShowError] = useState(false);
  const [itemData, setItemData] = useState<Product[]>([]);
  const [checkedItem, setCheckedItem] = useState<Record<number, boolean>>({});
  const [modifierCheckedDatastate, setModifierCheckedDatastate] = useState<any>(
    []
  );
  const paramId: any = useParams();
  const id: any = paramId.id ? parseInt(paramId.id) : undefined;

  useEffect(() => {
    const getItemData = async () => {
      try {
        Cookies.remove("formDataa");
        Cookies.remove("BillingAddress");
        const res = await apiGetItemData();
        const data = res.data as any;
        const items = data?.items.map((items: any) => items?.items);
        const orderFee = data.onlineOrderSettings.onlineOrderFee;
        const orderFeeLabel = data.onlineOrderSettings.onlineOrderFeeLabel;
        Cookies.set("orderFee", orderFee);
        Cookies.set("orderFeeLabel", orderFeeLabel);
        const flattenedItems = items?.flatMap((innerArray: any) => innerArray);
        const responseData = flattenedItems as Product[];
        const filteredData = responseData
          .map((item) => ({
            ...item,
            quantity: location.state ? location.state.quantity : 1,
          }))
          .filter((item: Product) => item.id === parseInt(id));

        let uniqueIds = new Set();
        const result = filteredData.filter((item: any) => {
          if (!uniqueIds.has(item.id)) {
            uniqueIds.add(item.id);
            return true;
          }
          return false;
        });

        if (location.state) {
          const modifiedResult = result.map((item) => ({
            ...item,
            modifierChecked: location.state.modifierChecked,
            cartItemId: location.state.cartItemId,
            note: location.state.note,
          }));
          const quantity = location.state.quantity;
          setQualitySelected(quantity);
          setItemData(modifiedResult);
        } else {
          setItemData(result);
        }
      } catch (error) {
        console.error(error);
      }
    };

    getItemData();
  }, [location.state]);

  useEffect(() => {
    const modifierCheckedData = itemData.map((ele) => ({
      ...ele,
      modifierChecked: modifierCheckedDatastate,
    }));
    setItemData(modifierCheckedData);
  }, [modifierCheckedDatastate, location.state]);

  useEffect(() => {
    const extractedValues: any = {};
    for (const key in location.state?.modifierChecked) {
      const innerObj = location.state?.modifierChecked[key];
      for (const innerKey in innerObj) {
        extractedValues[innerKey] = innerObj[innerKey];
      }
    }
    if (location.state) {
      setCheckedItem((prevCheckedItem) => ({
        ...prevCheckedItem,
        ...extractedValues,
      }));
      setModifierCheckedDatastate(location.state.modifierChecked);
    }
  }, [location.state]);

  useEffect(() => {
    const validateRequiredModifiers = itemData.every((item) =>
      item.modifierSets?.every((modify) => {
        const selectedCount = Object.values(
          modifierCheckedDatastate[modify.id] || {}
        ).filter(Boolean).length;
        return selectedCount >= (modify.noOfRequired || 0);
      })
    );

    const validateMaximumModifiers = itemData.every((item) =>
      item.modifierSets?.every((modify) => {
        const selectedCount = Object.values(
          modifierCheckedDatastate[modify.id] || {}
        ).filter(Boolean).length;
        return !modify.maximum || selectedCount <= modify.maximum;
      })
    );

    if (itemData[0]?.modifierSets) {
      setRequiredCheck(validateRequiredModifiers && validateMaximumModifiers);
    } else {
      setRequiredCheck(true);
    }
  }, [modifierCheckedDatastate, itemData]);

  return (
    <>
      {itemData.length !== 0 && (
        <div className={`nc-ProductDetailPage ${className}`}>
          <main className="container mt-5 mb-5 lg:mt-11">
            <div className="lg:flex">
              {itemData.map((item, index) => (
                <div key={index} className="w-full lg:w-[55%] ">
                  <div className="relative">
                    <div className="aspect-w-4 aspect-h-4">
                      <NcImage
                        src={item.imageUrl}
                        containerClassName="flex aspect-w-1 aspect-h-1 w-full h-0"
                        className="w-full rounded-lg object-cover"
                      />
                    </div>

                    {/* <LikeButton className="absolute right-3 top-3 " /> */}
                  </div>
                </div>
              ))}
              <div className="w-full lg:w-[45%] pt-10 lg:pt-0 lg:pl-7 xl:pl-9 2xl:pl-10">
                {/* {renderSectionContent()} */}
                <ProductContent
                  itemData={itemData}
                  modifierCheckedDatastate={modifierCheckedDatastate}
                  qualitySelected={qualitySelected}
                  setQualitySelected={setQualitySelected}
                  id={id}
                  quantity={itemData[0].quantity}
                  note={itemData[0].note}
                  setItemData={setItemData}
                  requiredCheck={requiredCheck}
                  setShowError={setShowError}
                  checkedItem={checkedItem}
                  showError={showError}
                  setModifierCheckedDatastate={setModifierCheckedDatastate}
                />
              </div>
            </div>
            <div className="mt-12 sm:mt-16 space-y-10 sm:space-y-16">
              <div className="block xl:hidden">{/* <Policy /> */}</div>
            </div>
          </main>
          <ModalViewAllReviews
            show={isOpenModalViewAllReviews}
            onCloseModalViewAllReviews={() =>
              setIsOpenModalViewAllReviews(false)
            }
          />
        </div>
      )}
    </>
  );
};

export default ProductDetailPage;
